import React, { useEffect } from 'react';
import { MenuItem, SxProps, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { OptionType } from 'types/components';

interface FormInputSelectProps {
    name: string;
    label?: string;
    required?: boolean;
    options: OptionType[] | undefined;
    sx?: SxProps | undefined;
    fullWidth?: boolean;
    helperText?: string;
    size?: 'small' | 'medium';
    disabled?: boolean;
    disableAutoSelectFirst?: boolean;
}

export const FormInputSelect: React.FC<FormInputSelectProps> = ({
    name,
    label,
    options,
    required,
    fullWidth,
    disabled,
    helperText = 'Field is required',
    sx,
    size = 'medium',
    disableAutoSelectFirst = false,
}) => {
    const { control, setValue, watch, trigger } = useFormContext();

    useEffect(() => {
        const value = watch(name);
        if (!value && options && options.length > 0 && !disableAutoSelectFirst) {
            setValue(name, options[0].value);
            trigger(name);
        }
    }, [options]);

    return (
        <Controller
            name={name}
            control={control}
            rules={{ required: required }}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    size={size}
                    {...field}
                    disabled={disabled}
                    fullWidth={fullWidth}
                    select
                    variant='outlined'
                    label={label}
                    value={field.value || ''}
                    error={!!error}
                    required={required}
                    sx={sx}
                    helperText={error ? (helperText ? helperText : error.message) : null}
                    margin='dense'>
                    {options?.map((option: any) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            )}
        />
    );
};
